import React from 'react'

import { Typography, ButtonBase } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      cursor: 'pointer',
      display: 'flex',
      maxWidth: '190px',
      padding: theme.spacing(4),
      color: theme.palette.text.primary,
    },
    buttonText: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    icon: {
      color: theme.palette.text.primary,
      height: '24px',
      marginLeft: theme.spacing(2),
      width: '24px',
    },
    text: {
      lineHeight: 1,
    },
  }),
)

interface ContextButtonProps {
  agentName?: string
  isOpen: boolean
  onHandleClick: (event: React.MouseEvent<HTMLElement>) => void
  dataHook?: string
}

const ContextButton: React.FC<ContextButtonProps> = ({
  agentName,
  isOpen,
  onHandleClick,
  dataHook,
}) => {
  const classes = useStyles()

  return (
    <ButtonBase
      disableRipple
      className={classes.button}
      onClick={(event) => onHandleClick(event)}
      data-hook={dataHook || ''}
    >
      <Typography
        className={classes.buttonText}
        variant="subtitle1"
        title={agentName || 'Nombre Agente'}
      >
        {agentName || 'Nombre Agente'}
      </Typography>
      {isOpen ? <ExpandLess className={classes.icon} /> : <ExpandMore className={classes.icon} />}
    </ButtonBase>
  )
}

export default ContextButton
